export default {
  tw: {
    "title":"日文老師Aoi",
    "description":"24h 隨時隨地上課。AI專業日文口說學習，輕鬆線上學日文。現在預約下載日語口說線上學習！",
    "homepage.appName": "日文老師Aoi",
    "nav.home": "首頁",
    "nav.event": "課程",
    "nav.download": "下載",
    "nav.contents": "功能介紹",
    "nav.course": "課程",
    "about.title": "毫無壓力練習日文口說",
    "about.discribe": "日文老師Aoi 擁有首創 AI 技術，讓你彷彿與真正的日文母語人士對話。",
    "download.title1": "快來",
    "download.title2": "下載",
    "download.title3": "體驗",
    "footer.companyName": "Deepbrain",
    "footer.privacy": "Privacy",
    "footer.term": "Term",
    "footer.affiliate":"聯盟行銷合作",
    "course.search": "搜尋",
    "course.jp": "日文",
    "course.hiragana": "拼音",
    "course.tw": "中文",
    "new_content.title": "零壓力環境下建立起信心",
    "new_content.discribe": "日文老師Aoi 提供了運用日文思考以及對話的機會。由於這是一款 AI，你能夠從容不迫且放鬆地學習，日文老師Aoi 永遠不會評判你。",
    "homepage.welcome": "<strong>{{name}}</strong>你好",
    "homepage.time": "現在時間是: {{time}}",
    "yukaEvent.specialEvent": "🧨新年優惠抽獎活動開跑囉💥",
    "yukaEvent.title1": "全台首創",
    "yukaEvent.title2AoiName": "AI老師",
    "yukaEvent.title2And": "和",
    "yukaEvent.title2YukaName": "Yuka老師",
    "yukaEvent.title3": "聯手教學課程上線囉",
    "yukaEvent.discribe1": "AI老師Aoi",
    "yukaEvent.discribe2": "與",
    "yukaEvent.discribe3": "Yuka老師",
    "yukaEvent.discribe4": "一起手把手教你日文口說",
    "yukaEvent.appIntroTitle": "Aoi老師特色",
    "yukaEvent.yukaIntroTitle": "專業日本人老師(中文一級棒)",
    "yukaEvent.yukaIntroName": "Yuka老師",
    "yukaEvent.yukaIntroDiscribe1": "出身於日本神戶市。",
    "yukaEvent.yukaIntroDiscribe2": "迄今累積了10年日文教育。",
    "yukaEvent.yukaIntroDiscribe3": "運營YouTube日本教學頻道及Instagram，總共20萬人粉絲與Yuka老師一起學習日文。",
    "yukaEvent.yukaIntroDiscribe4": "結合自己的教學經驗，設計了能提高口語能力的日文課。",
    "yukaEvent.yukaIntroDiscribe5": "希望我能幫助更多想提高日文能力的人，讓大家最短的時間內能得到最好的學習效果。",
    "yukaEvent.yukaIntroDiscribe6": "一緒に頑張りましょう!",
    "yukaEvent.appPlanTitle": "超優質課程內容",
    "yukaEvent.appPlanIntro0_1": "一年App智能口說會員(價值2990元)，",
    "yukaEvent.appPlanIntro0_2": "AI老師隨時隨地和你聊天，",
    "yukaEvent.appPlanIntro0_3": "幫您克服",
    "yukaEvent.appPlanIntro0_4": "怕開口說話",
    "yukaEvent.appPlanIntro0_5": "狀態",
    "yukaEvent.appPlanIntro1": "一年12回、合計720分鐘的限定直播課(提供回放影片隨時觀看)",
    "yukaEvent.appPlanIntro2": "Yuka老師線上直接詢問解惑、諮詢學習方向和目標",
    "yukaEvent.appPlanIntro3": "與老師進行口說練習，並糾正您的發音問題",
    "yukaEvent.appPlanIntro4": "App最佳學習方法教學",
    "yukaEvent.appPlanIntro5": "邀請您加入專屬LINE群，和同學們互動交流",
    "yukaEvent.appPlanIntro6": "多班制度，零基礎～N4基礎班與N3～N1進階班，提供不同上課內容加強學習效率",
    "yukaEvent.appPriceTitle": "課程方案",
    "yukaEvent.appSpecialEventPriceTitle": "新年優惠活動加碼",
    "yukaEvent.surpricePrice": "衝刺價格促銷",
    "yukaEvent.oldPrice": "5990元/年",
    "yukaEvent.newPrice": "4490元",
    "yukaEvent.newPriceUnit": "年",
    "yukaEvent.appSpecialEventPriceDesc1": "只要在2/5~2/12前購買，即可獲得抽獎資格！",
    "yukaEvent.appSpecialEventPriceDesc2": "我們將抽出5位幸運兒，可以獲得Yuka老師30分鐘線上一對一指導一次！",
    "yukaEvent.appConfusedTitle": "你有以下困擾嗎?",
    "yukaEvent.appLevelUpTitle": "上完課後你將會...",
    "yukaEvent.appLevelUpDescription_1": "再也不怕開口說日文！",
    "yukaEvent.appLevelUpDescription_2": "自信說日文，能夠達成溝通目的",
    "yukaEvent.appLevelUpDescription_3": "了解生活中常用的句型與語塊",
    "yukaEvent.appLevelUpDescription_4": "輕鬆對應日文對話，開展新話題",
    "yukaEvent.appLevelUpDescription_5": "與日本人溝通無距離",
    "yukaEvent.yukaClassIntroTitle": "你可以直播課中獲得",
    "yukaEvent.yukaClassDescription_1": "每月設定情境，和學員練習日文對話",
    "yukaEvent.yukaClassDescription_2": "Yuka介紹更多常用單字及句型",
    "yukaEvent.yukaClassDescription_3": "可以打開麥克風問問題",
    "yukaEvent.yukaClassDescription_4": "提供回放影片，隨時觀看",
    "yukaEvent.yukaClassDescription_5": "App最佳學習方法教學",
    "yukaEvent.yukaClassDescription_6": "基礎班與進階班多班制度，提供符合你程度的上課內容"
  },
  en: {
    "title":"日文老師Aoi",
    "description":"24h 隨時隨地上課。AI專業日文口說學習，輕鬆線上學日文。現在預約下載日語口說線上學習！",
    "homepage.appName": "Japanese teacher Aoi",
    "nav.home": "Home",
    "nav.event": "Event",
    "nav.download": "Download",
    "nav.contents": "Service",
    "nav.course": "Course",
    "about.title": "Learn Japanese by speaking with an AI",
    "about.discribe": "Practice realistic conversations. Get instant grammar feedback. Anytime, anywhere. ",
    "download.title1": "Come",
    "download.title2": "download",
    "download.title3": "and experience it",
    "footer.companyName": "Deepbrain",
    "footer.privacy": "Privacy",
    "footer.term": "Term",
    "footer.affiliate":"Affiliate marketing",
    "course.search": "Search",
    "course.jp": "Japanese",
    "course.hiragana": "Hiragana",
    "course.tw": "Chinese",
    "new_content.title": "Build confidence in a low-pressure environment",
    "new_content.discribe": "With Aoi, you can speak Japanese every day. No one will judge you for making mistakes. Speaking with Aoi is convenient AND stress-free!",
    "homepage.welcome": "<strong>{{name}}</strong>你好",
    "homepage.time": "Now is: {{time}}",
    "yukaEvent.specialEvent": "🧨新年優惠抽獎活動開跑囉💥",
    "yukaEvent.title1": "全台首創",
    "yukaEvent.title2AoiName": "AI老師",
    "yukaEvent.title2And": "和",
    "yukaEvent.title2YukaName": "Yuka老師",
    "yukaEvent.title3": "聯手教學課程上線囉",
    "yukaEvent.discribe1": "AI老師Aoi",
    "yukaEvent.discribe2": "與",
    "yukaEvent.discribe3": "Yuka老師",
    "yukaEvent.discribe4": "一起手把手教你日文口說",
    "yukaEvent.appIntroTitle": "Aoi老師特色",
    "yukaEvent.yukaIntroTitle": "專業日本人老師(中文一級棒)",
    "yukaEvent.yukaIntroName": "Yuka老師",
    "yukaEvent.yukaIntroDiscribe1": "出身於日本神戶市。",
    "yukaEvent.yukaIntroDiscribe2": "迄今累積了10年日文教育。",
    "yukaEvent.yukaIntroDiscribe3": "運營YouTube日本教學頻道及Instagram，總共20萬人粉絲與Yuka老師一起學習日文。",
    "yukaEvent.yukaIntroDiscribe4": "結合自己的教學經驗，設計了能提高口語能力的日文課。",
    "yukaEvent.yukaIntroDiscribe5": "希望我能幫助更多想提高日文能力的人，讓大家最短的時間內能得到最好的學習效果。",
    "yukaEvent.yukaIntroDiscribe6": "一緒に頑張りましょう!",
    "yukaEvent.appPlanTitle": "超優質課程內容",
    "yukaEvent.appPlanIntro0_1": "一年App智能口說會員(價值2990元)，",
    "yukaEvent.appPlanIntro0_2": "AI老師隨時隨地和你聊天，",
    "yukaEvent.appPlanIntro0_3": "幫您克服",
    "yukaEvent.appPlanIntro0_4": "怕開口說話",
    "yukaEvent.appPlanIntro0_5": "狀態",
    "yukaEvent.appPlanIntro1": "一年12回、合計720分鐘的限定直播課(提供回放影片隨時觀看)",
    "yukaEvent.appPlanIntro2": "Yuka老師線上直接詢問解惑、諮詢學習方向和目標",
    "yukaEvent.appPlanIntro3": "與老師進行口說練習，並糾正您的發音問題",
    "yukaEvent.appPlanIntro4": "App最佳學習方法教學",
    "yukaEvent.appPlanIntro5": "邀請您加入專屬LINE群，和同學們互動交流",
    "yukaEvent.appPlanIntro6": "多班制度，零基礎～N4基礎班與N3～N1進階班，提供不同上課內容加強學習效率",
    "yukaEvent.appPriceTitle": "課程方案",
    "yukaEvent.appSpecialEventPriceTitle": "新年優惠活動加碼",
    "yukaEvent.surpricePrice": "衝刺價格促銷",
    "yukaEvent.oldPrice": "5990元/年",
    "yukaEvent.newPrice": "4490元",
    "yukaEvent.newPriceUnit": "年",
    "yukaEvent.appSpecialEventPriceDesc1": "只要在2/5~2/12前購買，即可獲得抽獎資格！",
    "yukaEvent.appSpecialEventPriceDesc2": "我們將抽出5位幸運兒，可以獲得Yuka老師30分鐘線上一對一指導一次！",
    "yukaEvent.appConfusedTitle": "你有以下困擾嗎?",
    "yukaEvent.appLevelUpTitle": "上完課後你將會...",
    "yukaEvent.appLevelUpDescription_1": "再也不怕開口說日文！",
    "yukaEvent.appLevelUpDescription_2": "自信說日文，能夠達成溝通目的",
    "yukaEvent.appLevelUpDescription_3": "了解生活中常用的句型與語塊",
    "yukaEvent.appLevelUpDescription_4": "輕鬆對應日文對話，開展新話題",
    "yukaEvent.appLevelUpDescription_5": "與日本人溝通無距離",
    "yukaEvent.yukaClassIntroTitle": "你可以直播課中獲得",
    "yukaEvent.yukaClassDescription_1": "每月設定情境，和學員練習日文對話",
    "yukaEvent.yukaClassDescription_2": "Yuka介紹更多常用單字及句型",
    "yukaEvent.yukaClassDescription_3": "可以打開麥克風問問題",
    "yukaEvent.yukaClassDescription_4": "提供回放影片，隨時觀看",
    "yukaEvent.yukaClassDescription_5": "App最佳學習方法教學",
    "yukaEvent.yukaClassDescription_6": "基礎班與進階班多班制度，提供符合你程度的上課內容"
  },
};
